/**
 * Substitutes ${dateStringNdays} tokens in a layer source URL with today + (N-1) days
 * formatted as YYYY-MM-DD (UTC). N ∈ {1, 2, 3, 6, 7, 13, 14}.
 *
 * Why: EM2 wrapped FireSTARR layer URLs in JS template literals so dates were
 * substituted at runtime. Migration 026 copied those URLs into the EM3 catalog
 * as plain strings, leaving the tokens unsubstituted (see issue #526).
 *
 * The offset is (N-1), not N: FireSTARR publishes the N-day forecast against the
 * model run date (≈ yesterday), so the valid date the WMS serves for the "Nday"
 * layer is run + N = today + (N-1). Requesting today + N asked for dates the WMS
 * does not publish, leaving the 3/7/14-day layers blank. Verified against the live
 * FireSTARR time dimension.
 */
const SUPPORTED_DAYS = [1, 2, 3, 6, 7, 13, 14] as const;

function formatDate(d: Date): string {
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function substituteDateTokens(url: string, now: Date = new Date()): string {
  let result = url;
  for (const n of SUPPORTED_DAYS) {
    const token = `\${dateString${n}days}`;
    if (!result.includes(token)) continue;
    const future = new Date(now.getTime() + (n - 1) * 24 * 60 * 60 * 1000);
    result = result.split(token).join(formatDate(future));
  }
  return result;
}
